import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component';
import {UmpireGroup} from '../umpire-group';

export interface UmpireComponentGroup
  extends UmpireComponent<UmpireComponentTypeEnum.GROUP> {
  group: UmpireGroup;
}
